import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ISplashState } from './interfaces/common';
import logo from './assets/baran_main_logo.svg';

interface IProps {
	status: ISplashState;
	onRefetch: () => void;
}

export default function Splash({ status, onRefetch }: IProps) {
	const { t } = useTranslation();

	const isError = status === 'error';
	return (
		<Box className="z-50 flex h-full items-center justify-center bg-splash-bg bg-cover bg-center bg-no-repeat">
			<Box className="center flex flex-col items-center gap-5">
				<img src={logo} alt="logo" className="mb-4 h-40 w-40" />
				<Typography className="text-3xl font-bold text-grey-900">{isError ? t('error') : t('please_wait')}</Typography>
				{!isError && (
					<Box className="w-full">
						<LinearProgress />
					</Box>
				)}
				{isError && (
					<Button variant="text" onClick={onRefetch} startIcon={<RefreshIcon />}>
						{t('try_again')}
					</Button>
				)}
			</Box>
		</Box>
	);
}
